import { ThemeEvents } from '@theme/events';

class StoqPreorder extends HTMLElement {
  #controller;
  #observer;

  connectedCallback() {
    const form = this.closest('form');
    if (!form) return;

    this.#controller = new AbortController();
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal: this.#controller.signal,
    });
    // stoq:loaded fires when the embed requests its bundle, before the API exists.
    document.addEventListener('load', this.#onStoqScriptLoad, {
      capture: true,
      signal: this.#controller.signal,
    });
    this.#observer = new MutationObserver(this.#adoptDescription);
    this.#observer.observe(form, { childList: true, subtree: true });
    this.#adoptDescription();
    this.#syncStoqVariant();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#observer?.disconnect();
  }

  #adoptDescription = () => {
    const form = this.closest('form');
    // Stoq can render the embedded default late, or defer teardown after a size
    // change. Hidden messaging means this form must not submit preorder metadata.
    if (this.hidden) {
      form?.querySelectorAll('input.restock-rocket-form-input[data-stoq-injected="true"]').forEach((input) => {
        input.remove();
      });
    }
    const description = form?.querySelector('.restock-rocket-preorder-description');
    if (description && !this.contains(description)) {
      this.replaceChildren(description);
    }
  };

  #onStoqScriptLoad = (event) => {
    const scriptUrl = window._RestockRocketConfig?.scriptUrlProduct;
    if (!(event.target instanceof HTMLScriptElement) || !scriptUrl) return;
    if (event.target.src !== new URL(scriptUrl, document.baseURI).href) return;

    this.#syncStoqVariant();
  };

  #syncStoqVariant = () => {
    const variantId = this.closest('form')?.querySelector('input[name="id"]')?.value;
    const stoq = window._RestockRocket;
    const product = window._RestockRocketConfig?.product;
    if (!variantId || typeof stoq?.renderButtonForVariant !== 'function') return;
    if (String(product?.id) !== this.dataset.productId || !Array.isArray(product?.variants)) return;
    const variant = product.variants.find((variant) => String(variant.id) === variantId);
    if (!variant) return;

    stoq.renderButtonForVariant(variant.id);
  };

  #onVariantUpdate = (event) => {
    if (String(event.detail?.data?.productId) !== this.dataset.productId) return;

    const source = event.detail.data.html?.querySelector(
      `ap-stoq-preorder[data-section-id="${this.dataset.sectionId}"]`
    );
    if (!source) return;

    this.hidden = source.hidden;
    this.closest('form')?.querySelectorAll('.restock-rocket-preorder-description').forEach((description) => {
      description.remove();
    });
    this.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
    this.#adoptDescription();
    this.#syncStoqVariant();
  };
}

if (!customElements.get('ap-stoq-preorder')) {
  customElements.define('ap-stoq-preorder', StoqPreorder);
}
